"use client";

import { useState, useEffect } from "react";
import styles from "./NavigationFooter.module.scss";
import { usePathname, useRouter } from "next/navigation";
import { Theme } from "@/constants/enums";

import LensIcon from "@public/common/svg/lens-icon.svg";
import LensIconDark from "@public/common/svg/lens-icon-dark.svg";
import GlobeIcon from "@public/common/svg/globe-icon.svg";
import GlobeIconDark from "@public/common/svg/globe-icon-dark.svg";
import TilesIcon from "@public/common/svg/tiles-icon.svg";
import TilesIconDark from "@public/common/svg/tiles-icon-dark.svg";
import useWindowDimensions from "@/utils/useWindowDimensions";

const renderTabs = (theme: Theme) => {
    return [
        {
            name: "Home",
            icon: theme === Theme.DARK ? <LensIconDark /> : <LensIcon />,
            url: "/ask-datamuni",
        },
        {
            name: "Discover",
            icon: theme === Theme.DARK ? <GlobeIconDark /> : <GlobeIcon />,
            url: "/news",
        },
        {
            name: "Explore",
            icon: theme === Theme.DARK ? <TilesIconDark /> : <TilesIcon />,
            url: "/explore",
        },
    ];
};

export default function NavigationFooter() {
    const [selected, setSelected] = useState("");
    const [theme, setTheme] = useState<Theme>(Theme.LIGHT);
    const router = useRouter();
    const pathname = usePathname();
    const dimensions = useWindowDimensions();

    const tabs = renderTabs(theme);

    const handleClick = (tabName: string, url: string) => {
        setSelected(tabName);
        router.push(url);
    };

    useEffect(() => {
        const currentTab = tabs.find((tab) => tab.url.includes(pathname));
        setSelected(currentTab?.name ?? "");
    }, [pathname, tabs]);

    useEffect(() => {
        const savedTheme =
            localStorage.getItem("theme") === Theme.DARK
                ? Theme.DARK
                : Theme.LIGHT;
        if (savedTheme) {
            setTheme(savedTheme);
        }
    }, []);

    return (
        dimensions.width < 640 && (
            <div className={styles.container}>
                {tabs.map((tab) => (
                    <button
                        key={tab.name}
                        className={`${styles.tab} ${
                            selected === tab.name ? styles.active : ""
                        }`}
                        onClick={() => handleClick(tab.name, tab.url)}
                    >
                        <span className={styles.icon}>{tab.icon}</span>
                        {selected === tab.name && (
                            <span className={styles.label}>{tab.name}</span>
                        )}
                    </button>
                ))}
            </div>
        )
    );
}
